<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="6" lg="5">
      <div v-if="isPaySite && result">
        <v-alert :type="alertType" prominent>
          {{ resultMessage }}
        </v-alert>
        <p class="text-h6 text-center">{{ messages.ThankYou }}</p>
        <p class="text-center" v-if="returnUrl && countdown > 0">
          {{ redirectingText }}
        </p>
        <div class="text-center mb-3" v-if="returnUrl">
          <v-btn color="primary" rounded @click="goBack">{{ messages.BackButton }}</v-btn>
          <v-btn v-if="countdown > 0" text rounded color="grey darken-1" class="ml-2" @click="stopCountdown">
            {{ messages.RedirectStop || "Stay on this page" }}
          </v-btn>
        </div>
      </div>
      <div id="create" v-if="listingData">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <th>Name</th>
                <td>
                  : {{ listingData.firstName }} {{ listingData.lastName }}
                </td>
              </tr>
              <tr>
                <th>TXN ID</th>
                <td>: {{ listingData.txnID }}</td>
              </tr>
              <tr>
                <th>Status</th>
                <th v-if="listingData.status === 'Success'" style="color:green">
                  : {{ listingData.status }}
                </th>
                <th v-else style="color:red">: {{ listingData.status }}</th>
              </tr>
              <tr>
                <th>Transaction Ref.No.</th>
                <td>: {{ listingData.payUID }}</td>
              </tr>
              <tr>
                <th>Transaction Amount</th>
                <td>: Rs. {{ formatNumber(listingData.amount) }}/-</td>
              </tr>
              <tr>
                <th>Transaction Date</th>
                <td>
                  :
                  {{
                    formatDate(listingData.statusDate, "DD-MMM-YYYY hh:mm:ss")
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-data-table
          :mobile-breakpoint="mobilebreakpoint"
          :headers="headers"
          :items="listingData.payDatas"
          :hide-default-footer="true"
          :items-per-page="-1"
          item-key="installmentDate"
          class="elevation-4 mt-2"
        >
          <template v-slot:item.amount="{ item }">
            <span>{{ formatNumber(item.amount) }}</span>
          </template>
          <template v-slot:item.installmentDate="{ item }">
            <span>{{ formatDate(item.installmentDate, "DD-MMM-YY") }}</span>
          </template>
        </v-data-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";
import { formatDate, formatNumber } from "../util/helpers";
import { showSnackbar } from "../util/globalActions";

export default {
  name: "PaymentStatus",

  data: () => ({
    reqRules: [(v) => !!v || "Field is required"],
    validEdit: false,
    listingData: null,
    txnId: "",
    isPaySite: false,
    result: "",
    resultMessage: "",
    messages: {},
    returnUrl: "",
    countdown: 0,
    timer: null,
    permission: {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isDownload: false,
    },
    saveLoading: false,
    message: "",
    snackbar: false,
    length: 4,
    tab: null,
    mobilebreakpoint: "200",
    headers: [
      {
        text: "Installment Date",
        value: "installmentDate",
        width: "120px",
        sortable: false,
      },
      {
        text: "Amount",
        value: "amount",
        width: "150px",
        align: "right",
        sortable: false,
      },
    ],
  }),
  created() {},
  mounted() {
    const self = this;
    self.txnId = self.$route.params["txnid"];
    // Pay site: reached from the PayU redirect with a signed link (or no txnid when PayU sent nothing back).
    self.isPaySite = !!self.$route.query.sig || !self.txnId;
    if (self.apiUrl) self.loadData();
  },
  computed: {
    apiUrl: get("app/apiUrl"),
    alertType() {
      if (this.result === "Success") return "success";
      if (this.result === "Canceled" || this.result === "Pending") return "warning";
      return "error";
    },
    redirectingText() {
      return (this.messages.Redirecting || "").replace("{0}", this.countdown);
    },
  },
  watch: {
    // config.json is read in App.vue; wait for the API url before loading.
    apiUrl: function (value) {
      if (value) this.loadData();
    },
  },
  methods: {
    formatNumber,
    formatDate,

    loadData() {
      if (this.isPaySite) this.showPaySiteData();
      else this.showData();
    },

    showPaySiteData() {
      const self = this;

      axios({
        url: self.apiUrl + "api/Fees/PayGateStatus/" + (self.txnId ? encodeURIComponent(self.txnId) : ""),
        method: "GET",
        params: { sig: self.$route.query.sig, result: self.$route.query.result },
        responseType: "json",
      })
        .then(function (res) {
          self.messages = res.data.messages || {};
          self.result = res.data.result || "Failed";
          self.resultMessage = res.data.message;
          self.listingData = res.data.payment || null;
          self.returnUrl = res.data.returnUrl;
          self.startCountdown(res.data.redirectSeconds);
        })
        .catch(function (err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    startCountdown(seconds) {
      const self = this;
      if (!self.returnUrl) return;
      self.countdown = seconds > 0 ? seconds : 10;
      self.timer = setInterval(function () {
        self.countdown -= 1;
        if (self.countdown <= 0) self.goBack();
      }, 1000);
    },

    // Lets the student read or note the details; they leave with the Back button.
    stopCountdown() {
      clearInterval(this.timer);
      this.countdown = 0;
    },

    goBack() {
      clearInterval(this.timer);
      window.location.href = this.returnUrl;
    },

    showData() {
      const self = this;

      axios({
        url: self.apiUrl + "api/Fees/PaymentDetails/" + self.txnId,
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data;
          console.log(self.listingData);
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
